import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const DesignationList = Loadable(lazy(() => import('./DesignationList')));
const AddDesignation = Loadable(lazy(() => import('./AddDesignation')));

const DesignationRoutes = [
	{
		path: '/Designation/list',
		element: <DesignationList />,
		auth: authRoles.admin,
	},
	{
		path: '/Designation/manage',
		element: <AddDesignation />,
		auth: authRoles.admin,
	},
];

export default DesignationRoutes;
